import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const AbhaProfileModal = ({ open, onClose, profiles = [], onNext }) => {
  const [selectedProfileIndex, setSelectedProfileIndex] = useState(0);
  const [authType, setAuthType] = useState("aadhaar-verify");

  const handleNext = () => {
    if (selectedProfileIndex !== null && profiles[selectedProfileIndex]) {
      const selectedProfile = profiles[selectedProfileIndex];
      if (onNext) {
        onNext(selectedProfile, authType);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "25px",
          padding: "10px 0 20px 0",
        },
      }}
    >
      <DialogTitle sx={{ px: 4, fontWeight: 700, fontSize: "1.2rem" }}>
        {profiles.length} Active Profile{profiles.length > 1 ? 's' : ''}
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 12, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 4 }}>
        <p className="profile-subtitle">
          We have found the following ABHA numbers linked to the provided mobile
          number. Select the ABHA profile you wish to log in.
        </p>

        <RadioGroup
          value={selectedProfileIndex}
          onChange={(e) => setSelectedProfileIndex(Number(e.target.value))}
        >
          {profiles.map((profile, index) => (
            <div
              key={index}
              className="profile-card"
              style={{
                border: selectedProfileIndex === index ? '2px solid #B056CC' : '1px solid #ddd',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '16px',
                cursor: 'pointer',
                position: 'relative',
              }}
              onClick={() => setSelectedProfileIndex(index)}
            >
              <div className="profile-info" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
                <FormControlLabel
                  value={index}
                  control={<Radio />}
                  label=""
                  sx={{ margin: 0 }}
                />

                <div className="profile-avatar">
                  {profile?.profilePhoto && (
                    <img
                      src={`data:image/jpeg;base64,${profile?.profilePhoto}`}
                      alt="Profile"
                      className="avatar-img"
                      style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                  )}
                </div>

                <div className="profile-details" style={{ flex: 1 }}>
                  <h6 className="profile-name" style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600 }}>
                    {profile?.name}
                  </h6>
                  <div className="profile-row" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span className="label" style={{ fontSize: '13px', color: '#666' }}>ABHA Number</span>
                    <span className="value" style={{ fontSize: '13px', fontWeight: 500 }}>{profile?.ABHANumber}</span>
                  </div>
                  <div className="profile-row" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className="label" style={{ fontSize: '13px', color: '#666' }}>Gender</span>
                    <span className="value" style={{ fontSize: '13px', fontWeight: 500 }}>
                      {profile?.gender === 'M' ? 'Male' : profile?.gender === 'F' ? 'Female' : 'Other'}
                    </span>
                  </div>
                </div>

                {profile?.kycVerified && (
                  <div className="profile-verified" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <CheckCircleIcon
                      sx={{ color: "#27AE60", fontSize: "18px" }}
                    />
                    <span style={{ fontSize: '12px', color: '#27AE60', fontWeight: 500 }}>Verified</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </RadioGroup>

        {/* Authentication Type Dropdown */}
        <FormControl fullWidth sx={{ mt: 3 }}>
          <InputLabel id="auth-type-label">Authentication type*</InputLabel>
          <Select
            labelId="auth-type-label"
            value={authType}
            label="Authentication type*"
            onChange={(e) => setAuthType(e.target.value)}
          >
            <MenuItem value="aadhaar-verify">Aadhaar OTP</MenuItem>
            <MenuItem value="mobile-verify">Mobile OTP</MenuItem>
          </Select>
        </FormControl>

        {/* Next Button */}
        <Button
          fullWidth
          variant="contained"
          sx={{
            marginTop: 4,
            background: "linear-gradient(90deg, #D063CA, #B056CC)",
            textTransform: "none",
            borderRadius: "25px",
            padding: "10px 0",
          }}
          onClick={handleNext}
          disabled={selectedProfileIndex === null}
        >
          Next
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AbhaProfileModal;
